import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const EmptyData = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16 10.0556V16.5M16 22.9606L16.0163 22.9427M11.125 2H3V6.83333M3 14.8889V18.1111M29 14.8889V18.1111M20.875 2H29V6.83333M11.125 31H3V26.1667M20.875 31H29V26.1667", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default EmptyData;
